import { Col, Collapse, Typography } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";

const { Panel } = Collapse;

interface ImportErrorsPropsTypes {
  errorsPerCode: any[] | undefined;
}

export default function ImportPerCode(props: ImportErrorsPropsTypes): React.ReactElement {
  const { errorsPerCode } = props;

  const { t } = useTranslation();

  const showErrorsImportClients = () => {
    return errorsPerCode?.map(item => {
      return (
        <div className="import-error-row" key={item?.code}>
          <span className="import-field">&#10148; {item?.code}: </span>
          {item?.errors.map((value: any, index: number) => {
            let color;
            const errorMessage =
              value?.messages?.length > 1 ? value.messages?.join(", ") : value.messages[0];

            if (value?.type?.value === "WARNING") {
              color = "#faad14";
            } else if (value?.type?.value === "ERROR") {
              color = "#d9363e";
            }

            return (
              <span key={index}>
                <span className="import-message-field">- {`${value?.field}`} -</span>
                <span className="import-message" style={{ color }}>
                  {errorMessage}
                </span>
              </span>
            );
          })}
        </div>
      );
    });
  };

  const subtitle = () => {
    return (
      <div className="subtitles">
        <span className="subtitle">
          <div style={{ background: "#d9363e" }} className="square"></div>
          <span className="subtitle-text">{t("The line could not be imported")}</span>
        </span>
        <span className="subtitle">
          <div style={{ background: "#faad14" }} className="square"></div>
          <span className="subtitle-text">
            {t("The field in the line had an error and was ignored")}
          </span>
        </span>
      </div>
    );
  };

  return (
    <>
      {errorsPerCode && errorsPerCode.length > 0 && (
        <Col sm={16} xs={24} className="errors-col">
          <Typography.Title level={5}>{t("Import errors")}</Typography.Title>
          <Col xs={24} sm={24}>
            <Collapse defaultActiveKey={["1"]}>
              <Panel header={t("Errors")} key="1">
                {showErrorsImportClients()}
              </Panel>
            </Collapse>
            {subtitle()}
          </Col>
        </Col>
      )}
    </>
  );
}
